export default "cc19623de55c4c5a.svg"